//
//
//
//
//

import { getToken, setToken, removeToken } from '@/store/getToken'
import promise from '@/axios/promise'
import { BASIC } from "@/config/constant"
export default {
    name:'',
    data(){
        return {
            taskId: this.$route.query.taskId,
            taskUrl: this.$route.query.taskUrl,
            taskType: this.$route.query.taskType,
            taskTopic: this.$route.query.taskTopic,
            showConfirm: this.$route.query.showConfirm,
            businessKey: this.$route.query.businessKey,
            username: this.$route.query.username,
            wechatCode: this.$route.query.wechatCode,
        }
    },
    methods:{
        forwardToTaskDetail(){
            this.$router.push({
                path: this.taskUrl,
                query: {
                    taskTopic: this.taskTopic,
                    taskId: this.taskId,
                    taskType: this.taskType,
                    showConfirm: this.showConfirm,
                    businessKey: this.businessKey,
                    taskDefinitionKey: this.taskDefinitionKey
                }
            });
        },
        forwardToTaskList(){
            this.$router.push({ path: '/wechat/taskCenter'});
        },
        getTokenByWechatCode(){//获取token
            promise({
                url:"/token/generateToken",
                method:'post',
                params:{username:this.username,password:"",wechatCode:this.wechatCode}
            }).then(res=>{
                debugger;
                if(res.status=='S'){
                    setToken(res.token);
                    sessionStorage.setItem('username', this.username)
                    this.getTask();
                }else{
                    this.$router.push({path:'/login'});
                }
            });
        },
        getTask(){//查看当前任务
            var self=this;
            promise({
                url:BASIC+"/task/id",
                method:'get',
                params:{"taskId":this.taskId}
            }).then(res=>{
                if(res.code==0){
                //存在跳转到任务详情
                    var task=res.data;
                    self.taskTopic=task.taskTopic;
                    self.taskDefinitionKey=task.taskDefinitionKey;
                    self.showConfirm=task.showConfirm;
                    self.businessKey=task.businessKey;
                    self.taskType="undo";
                    self.forwardToTaskDetail();
                }else{
                //不存在跳转到代办列表
                    this.forwardToTaskList();
                }
            });
        }
    },
    mounted(){
        this.getTokenByWechatCode();
    }
}



// WEBPACK FOOTER //
// ./src/view/wechat/taskLoading.vue